









import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../system/mixins";
import { CommonComponentsAccessibleMixin } from "../../../../document/editor/mixins";
import { MenuPane } from "../../../../panes";
import { EditingDocument } from "../..";

@Component({
  components: {
    MenuPane,
  }
})
export default class NaturalTextMenu extends Mixins(ModelEditableMixin, CommonComponentsAccessibleMixin) {
  get editingDocument(): EditingDocument {
    return this.editingSource;
  }

  get isEnable(): boolean {
    return this.readDocumentOrDefault(d => d.isNaturalTextEnable, false);
  }

  get naturalText(): string {
    return this.readDocumentOrDefault(d => d.naturalText, "");
  }

  private readDocumentOrDefault<T>(read: (d: EditingDocument) => T, defaultValue: T): T {
    return this.editingDocument
      ? read(this.editingDocument)
      : defaultValue;
  }

  showNaturalText(): void {
    this.commonComponents.dialogs.valueConfirmation.preview.show("テキスト", this.naturalText, "calc(100vh - 200px)", "96vw", "");
  }
}
